// Mirror of backend pricing.py for instant, accurate cost labels in the UI.
const STANDARD_KINDS = new Set(["convert:office", "reverse:docx", "reverse:images", "carousel"]);

export function baseTier(kind, ocr = false) {
  if (kind === "searchable") return 3;
  if (kind === "reverse:docx" && ocr) return 3;
  if (STANDARD_KINDS.has(kind)) return 2;
  return 1;
}

export function tierName(kind, ocr = false) {
  return ["", "Basic", "Standard", "Advanced"][baseTier(kind, ocr)];
}

// Cost including large-document overage (Standard/Advanced only) and team premium.
export function opCost(user, kind, { pages = null, ocr = false } = {}) {
  const tier = baseTier(kind, ocr);
  const cap = user?.pricing?.page_cap || 30;
  const over = tier >= 2 && pages && pages > cap ? Math.ceil((pages - cap) / cap) : 0;
  const premium = user?.pricing?.team_premium_applied || 0;
  return tier + over + premium;
}

export function creditLabel(n) {
  return `${n} credit${n === 1 ? "" : "s"}`;
}
